export default function CategoryBars({ scores = {}, labels = {} }) {
  const tone = (s) => (s >= 75 ? "bg-ok" : s >= 50 ? "bg-warn" : "bg-bad");
  const entries = Object.entries(scores);
  return (
    <div className="space-y-4" data-testid="category-bars">
      {entries.map(([k, v]) => (
        <div key={k} className="grid grid-cols-12 items-center gap-4">
          <div className="col-span-4 text-sm pdf-text">{labels[k] || k}</div>
          <div className="col-span-7 h-2 bg-navy-700 relative overflow-hidden">
            <div className={`h-full ${tone(v)} transition-all duration-700`} style={{ width: `${v}%` }} />
          </div>
          <div className="col-span-1 text-sm tabular-nums text-right pdf-text">{Math.round(v)}</div>
        </div>
      ))}
    </div>
  );
}
